import type { SxProps, Theme } from "@mui/material/styles";

export const loading: SxProps<Theme> = (theme) => ({
  display: "flex",
  justifyContent: "center",
  py: theme.spacing(6),
});
